import type { CSSProperties, ReactNode } from 'react';

/** Clip-rect pattern: invisible but still read by assistive technology. */
const HIDDEN: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
  border: 0,
};

export function VisuallyHidden({ children }: { children: ReactNode }) {
  return <span style={HIDDEN}>{children}</span>;
}
